export class RuntimeError extends Error {
  constructor(message: string, options: ErrorOptions) {
    super(message, options);
  }
}
